 
import BACKEND_URL from 'constants/backendUrl';
import User from 'core/models/user';
import React, { FC, PropsWithChildren, useEffect, useState } from 'react';
import { GET } from 'utils/http';
import { useSessionStore } from 'stores/session';
import { setUserPropertiesForAmplitude } from 'config/tracking';
import CandidateStatus from 'core/enums/candidateStatus';
import { UserRole } from 'core/enums/userRole';

interface ResponseData {
    user: User;
}

export const sessionFetcher = async () => {
    const { user } = (await GET(`${BACKEND_URL}/api/auth/me`)) as ResponseData;
    return user;
};

const AuthInitializer: FC<PropsWithChildren> = ({ children }) => {
    const setUser = useSessionStore((s) => s.setUser);
    const logout = useSessionStore((s) => s.logout);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        sessionFetcher()
            .then((user) => {
                const isUserB2B = !user.isB2C && user.role === UserRole.Candidate;
                // Logout if user is B2B and has no paid license, neither freeaccess
                if (isUserB2B &&
                    user.status !== CandidateStatus.InTrialPeriod &&
                    user.status !== CandidateStatus.WithValidLicense
                ) {
                    logout();
                } else {
                    setUser(user);
                    setUserPropertiesForAmplitude(user.id);
                }
            })
            .catch(() => logout())
            .finally(() => setLoading(false));
    }, []);

    return <>{!loading && children}</>;
};

export default AuthInitializer;
